<template>
  <div class="layout-seo-blocks">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-seo-blocks {
  margin: 6em 0;
}
.container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.875em;
  & > * {
    background: var(--light);
    border-radius: 10px;
    padding: 2.5em;
    padding-right: 30%;
    position: relative;
    padding-bottom: 8em;
    overflow: hidden;
    & > img {
      position: absolute;
      left: 73%;
      width: 40%;
    }
    div {
      margin-bottom: 0.5em;
    }
    p {
      font-size: 1.125em;
      line-height: 150%;
      margin: 0.5em 0;
    }
    & > a {
      background: var(--color);
      color: #fff;
      font-size: 1.125em;
      font-weight: 500;
      padding: 0.7em 1.2em;
      border-radius: 100px;
      position: absolute;
      right: 2.5em;
      bottom: 2.5em;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .layout-seo-blocks {
    padding: 0 var(--gap);
  }
  .container {
    display: block;
    img {
      position: relative;
      /* float: right; */
      left: 0;
      margin: 0 auto;
      width: 100%;
    }
    & > * {
      padding: 1.5em;
      margin-bottom: 1em;
      & > a {
        background: var(--color);
        color: #fff;
        font-size: 1.125em;
        font-weight: 500;
        padding: 0.7em 1.2em;
        border-radius: 100px;
        position: relative;
        right: unset;
        bottom: unset;
        cursor: pointer;
        transition: 0.3s;
        margin-top: 2em;
        display: inline-block;
        &:hover {
          transform: scale(1.05);
        }
      }
    }
  }
}
</style>
